/**
 * One gateway in a drop's gateway picker (user, 19/10/2026: "which gateways
 * use AI — colours for each icon — numbers"): its letter in its colour, its
 * name and route number, and what it sends with — its sender IDs, or the AI
 * badge with how many names — the same cell as the Gateways list.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Check } from 'lucide-react';

import type { DraftGateway } from '../../../../../../drop-generator.types';
import { sendsWithFor } from '../../../../gateways/senders/sender-words';
import { SendsWithCell } from '../../../../gateways/senders/SendsWithCell';
import { GatewayLetter } from './GatewayLetter';

interface Props {
  gateway: DraftGateway;
  index: number;
  name: string;
  selected: boolean;
  onChoose: () => void;
}

export const LaneOption: FC<Props> = ({ gateway, index, name, selected, onChoose }) => {
  const lane = gateway.pool[index];
  const sends = sendsWithFor(gateway.senderDefaults, lane);
  const words = [sends.names.join(' / '), sends.ai !== null ? `AI ${sends.ai} names` : null].filter(Boolean).join(' + ') || 'no sender';
  return (
    <button
      type="button"
      role="option"
      aria-selected={selected}
      aria-label={`${name} #${lane.routeId} · ${words}`}
      onClick={onChoose}
      className="flex w-full items-center gap-2 rounded-md p-2 text-left hover:bg-accent"
    >
      <GatewayLetter index={index} className="h-5 w-5 text-[11px]" />
      <span className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="flex min-w-0 items-center gap-1.5">
          <span className="truncate text-xs font-medium">{name}</span>
          <span className="shrink-0 font-mono text-[10.5px] tabular-nums text-muted-foreground">#{lane.routeId}</span>
        </span>
        <SendsWithCell value={sends} max={3} />
      </span>
      {selected ? <Check className="h-3.5 w-3.5 shrink-0 text-primary" /> : null}
    </button>
  );
};
